/* Regalos progresivos por numero de botellas - Dear Noel
   Solo cuenta botellas Remember Me: otros productos (p. ej. el Memory Bunny) NO activan la barra.
   Los regalos son para los primeros 50 pedidos del dia (hay que cumplirlo de verdad). */
(function () {
  if (window.__dnGifts) return; window.__dnGifts = true;
  var BOTTLE = 'remember-me-bottle';
  var DEFAULTS = [
    { n: 1, icon: '📖', name: 'Guía de mensajes', price: 10, img: '' },
    { n: 2, icon: '🚚', name: 'Envío gratis', price: 4.99, img: '' },
    { n: 3, icon: '🎁', name: 'Kit de personalización', price: 20, img: '' }
  ];
  // Ajustes del Personalizador (Configuración del tema › Regalos del carrito); si faltan, valores por defecto
  var CFG = window.DN_GIFTS || {};
  var GIFTS = (CFG.gifts && CFG.gifts.length ? CFG.gifts : DEFAULTS).map(function (g, i) {
    var d = DEFAULTS[i] || DEFAULTS[DEFAULTS.length - 1];
    var has = function (v) { return v !== null && v !== undefined && v !== ''; };
    return {
      n: has(g.n) && parseInt(g.n, 10) > 0 ? parseInt(g.n, 10) : d.n,
      icon: g.icon || d.icon,
      name: g.name || d.name,
      price: has(g.price) && !isNaN(parseFloat(g.price)) ? parseFloat(g.price) : d.price,
      img: g.img || ''
    };
  }).sort(function (a, b) { return a.n - b.n; });
  var MAXN = GIFTS.reduce(function (m, g) { return Math.max(m, g.n); }, 1);
  var FMT = CFG.money || '${{amount}}';
  function money(v) {
    var fixed = (Math.round(v * 100) / 100).toFixed(2), parts = fixed.split('.');
    var a = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','), b = parts[1];
    return FMT.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return a;
      if (k === 'amount_with_comma_separator') return a.replace(/,/g, '.') + ',' + b;
      if (k === 'amount_no_decimals_with_comma_separator') return a.replace(/,/g, '.');
      return a + '.' + b;
    });
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var css = '.dng{margin:14px 0;padding:14px;border-radius:14px;background:#fff8f3;border:1px solid rgba(122,31,43,.15);font-family:inherit}' +
    '.dng-h{margin:0 0 10px;font-size:1.4rem;font-weight:600;text-align:center;line-height:1.35;color:#3b2a20}' +
    '.dng-lim{margin:-4px 0 10px;text-align:center;font-size:1.2rem;line-height:1.3;color:#7a1f2b}' +
    '.dng-bar{position:relative;height:6px;border-radius:6px;background:rgba(122,31,43,.12);margin:0 16% 12px;overflow:hidden}' +
    '.dng-bar span{position:absolute;left:0;top:0;bottom:0;border-radius:6px;background:#7a1f2b;transition:width .4s ease}' +
    '.dng-row{display:grid;grid-template-columns:repeat(' + GIFTS.length + ',1fr);gap:8px}' +
    '.dng-g{position:relative;border-radius:12px;padding:10px 6px;text-align:center;background:#fff;border:1px solid rgba(0,0,0,.07);display:flex;flex-direction:column;align-items:center;gap:3px;min-height:104px;justify-content:center}' +
    '.dng-g.on{border-color:#2f7d4f;box-shadow:0 0 0 1px #2f7d4f inset}' +
    '.dng-i{font-size:2.2rem;line-height:1}' +
    '.dng-i.dng-img{display:block;width:3.2rem;height:3.2rem;border-radius:8px;overflow:hidden;font-size:0}' +
    '.dng-i.dng-img img{display:block;width:100%;height:100%;object-fit:cover}' +
    '.dng-g.off .dng-i.dng-img{filter:none;opacity:1}' +
    '.dng-g.off .dng-i.dng-img img{filter:grayscale(1);opacity:.55}' +
    '.dng-t{font-size:1.2rem;font-weight:600;line-height:1.2;color:#3b2a20}' +
    '.dng-v{font-size:1.1rem;line-height:1.2}' +
    '.dng-v s{opacity:.55;margin-right:4px}.dng-v b{color:#2f7d4f}' +
    '.dng-g.off .dng-i,.dng-g.off .dng-t{filter:blur(5px);opacity:.6;user-select:none}' +
    '.dng-lock{position:absolute;top:6px;right:6px;font-size:1.2rem}' +
    '.dng-u{font-size:1.05rem;color:#7a1f2b;font-weight:600;line-height:1.2}' +
    '.dng-ok{position:absolute;top:6px;right:6px;width:16px;height:16px;border-radius:50%;background:#2f7d4f;color:#fff;font-size:1rem;line-height:16px}' +
    '#CartDrawer .dng{margin:0 0 12px}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function html(count) {
    var unlocked = GIFTS.filter(function (g) { return g.n <= count; });
    var next = GIFTS.filter(function (g) { return g.n > count; })[0];
    var total = unlocked.reduce(function (s, g) { return s + g.price; }, 0);
    var msg;
    if (!next) msg = '🎉 ¡Desbloqueaste todos los regalos! <b>' + money(total) + '</b> en regalos GRATIS';
    else if (unlocked.length >= 1) msg = '¡Tienes ' + unlocked.length + (unlocked.length === 1 ? ' regalo' : ' regalos') + '! Agrega <b>' + (next.n - count) + ' botella' + (next.n - count > 1 ? 's' : '') + ' más</b> y descubre el siguiente 🎁';
    else msg = 'Elige tu paquete y desbloquea regalos gratis 🎁';
    var pct = Math.min(100, Math.max(0, count / MAXN * 100));
    var cards = GIFTS.map(function (g) {
      var on = count >= g.n;
      var icon = g.img
        ? '<span class="dng-i dng-img"><img src="' + esc(g.img) + '" alt="' + esc(on ? g.name : 'Regalo sorpresa') + '" loading="lazy"></span>'
        : '<span class="dng-i">' + (on ? g.icon : '🎁') + '</span>';
      return '<div class="dng-g ' + (on ? 'on' : 'off') + '">' +
        (on ? '<span class="dng-ok">✓</span>' : '<span class="dng-lock">🔒</span>') +
        icon +
        '<span class="dng-t">' + (on ? esc(g.name) : 'Regalo sorpresa') + '</span>' +
        (on ? '<span class="dng-v"><s>' + money(g.price) + '</s><b>GRATIS</b></span>'
            : '<span class="dng-u">Con ' + g.n + ' botellas</span>') +
        '</div>';
    }).join('');
    return '<p class="dng-h">' + msg + '</p><p class="dng-lim">⏳ Regalos para los <b>primeros 50 pedidos del día</b></p><div class="dng-bar"><span style="width:' + pct + '%"></span></div><div class="dng-row">' + cards + '</div>';
  }
  function unitsOf(title) { var n = parseInt(String(title || ''), 10); return n > 0 ? n : 1; }

  // Pagina de producto: segun el paquete seleccionado (solo en la pagina de la botella)
  function productCount() {
    var on = document.querySelector('[data-dnp] .dnp-c.on');
    if (on) return unitsOf(on.getAttribute('data-value'));
    var chk = document.querySelector('variant-selects input[type=radio]:checked');
    return chk ? unitsOf(chk.value) : 1;
  }
  function renderProduct() {
    var pk = document.querySelector('[data-dnp]'); if (!pk) return;
    var box = document.querySelector('.dng[data-where="product"]');
    if (!box) { box = document.createElement('div'); box.className = 'dng'; box.setAttribute('data-where', 'product'); pk.insertAdjacentElement('afterend', box); }
    var c = productCount();
    if (box.getAttribute('data-c') !== String(c)) { box.setAttribute('data-c', c); box.innerHTML = html(c); }
  }

  // Carrito lateral: segun las BOTELLAS Remember Me en el carrito (otros productos no cuentan)
  var cartTimer = null;
  async function renderCart() {
    var head = document.querySelector('#CartDrawer .drawer__header'); if (!head) return;
    var cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
    var count = 0;
    cart.items.forEach(function (i) { if (i.handle === BOTTLE) count += unitsOf(i.variant_title) * i.quantity; });
    var box = document.querySelector('#CartDrawer .dng');
    if (!count) { if (box) box.remove(); return; }
    if (!box) {
      box = document.createElement('div'); box.className = 'dng'; box.setAttribute('data-where', 'cart');
      var after = document.querySelector('#CartDrawer [data-dnc-ship]') || head;
      after.insertAdjacentElement('afterend', box);
    }
    if (box.getAttribute('data-c') !== String(count)) { box.setAttribute('data-c', count); box.innerHTML = html(count); }
  }
  function scheduleCart() { clearTimeout(cartTimer); cartTimer = setTimeout(function () { renderCart().catch(function () {}); }, 200); }

  function start() {
    renderProduct();
    scheduleCart();
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.dnp-c')) setTimeout(renderProduct, 60); });
    document.addEventListener('change', function () { setTimeout(renderProduct, 80); });
    var drawer = document.getElementById('CartDrawer');
    if (drawer) new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) { var t = m[i].target; if (!(t.closest && t.closest('.dng'))) { scheduleCart(); return; } }
    }).observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
